import { axios } from '@/di-container/axios';
import {
  GetQuickConsultBasicInfoGateway,
  GetQuickConsultDetailGateway,
  CreateQuickConsultGateway,
  GetQuickConsultChannelInfoGateway,
} from '@remodeling/remodeling-manager';

export const quickConsultGateway = () => {
  return {
    getBasic: new GetQuickConsultBasicInfoGateway(axios),
    getChannel: new GetQuickConsultChannelInfoGateway(axios),
    createQuickConsult: new CreateQuickConsultGateway(axios),
    getDetail: new GetQuickConsultDetailGateway(axios),
  };
};
